export default "__VITE_ASSET__OxixqUzy__"